import { render, staticRenderFns } from "./dialogProtDetail.vue?vue&type=template&id=72e872c2&"
import script from "./dialogProtDetail.vue?vue&type=script&lang=js&"
export * from "./dialogProtDetail.vue?vue&type=script&lang=js&"
import style0 from "./dialogProtDetail.vue?vue&type=style&index=0&id=72e872c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports